import { createSelector } from '@ngrx/store';
import { CoreState, getCoreState } from '../../../store/reducers';
import { LoyaltyCurrencyState } from '../reducers/loyalty-currency.reducer';

const getLoyaltyCurrencyState = createSelector(
  getCoreState,
  (state: CoreState) => state.loyaltyCurrency,
);

const getSelected = (state: LoyaltyCurrencyState) => state.selected;

export const getLoyaltyCurrencySelected = createSelector(
  getLoyaltyCurrencyState,
  getSelected,
);
